import React, { useEffect } from 'react';
import { DotLoader } from 'react-spinners';
import { useGeolocation } from '../contexts/GeolocationContext';

/**
 * Wrapper component that handles geo-based redirection for Indian visitors
 * Shows loading state while checking geolocation and redirects if needed
 */
const GeoRedirectWrapper = ({ children }) => {
  const { isLoading, shouldRedirect, getRedirectUrl } = useGeolocation();

  useEffect(() => {
    if (shouldRedirect()) {
      const redirectUrl = getRedirectUrl();
      if (redirectUrl) {
        // Use replace to avoid back button issues
        window.location.replace(redirectUrl);
      }
    }
  }, [shouldRedirect, getRedirectUrl]);

  // Show minimal loading state while checking geolocation
  if (isLoading) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          zIndex: 9999,
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <DotLoader color={'#000000'} loading={true} size={30} />
          <div
            style={{
              marginTop: '20px',
              fontFamily: 'Helvetica, sans-serif',
              color: '#353232',
              fontSize: '14px',
              fontWeight: '400',
            }}
          >
            Loading...
          </div>
        </div>
      </div>
    );
  }

  // If redirecting, show loading state (though user will be redirected quickly)
  if (shouldRedirect()) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          zIndex: 9999,
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <DotLoader color={'#000000'} loading={true} size={30} />
          <div
            style={{
              marginTop: '20px',
              fontFamily: 'Helvetica, sans-serif',
              color: '#353232',
              fontSize: '14px',
              fontWeight: '400',
            }}
          >
            Redirecting...
          </div>
        </div>
      </div>
    );
  }

  // Normal case - render the app
  return children;
};

export default GeoRedirectWrapper;
